module.exports = __webpack_public_path__ + "static/media/football-trophy.74c80589.svg";